import Vue from 'vue'

export default {  
  getCurrentCourse ({ commit }, branchUid) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$api.courses().show(branchUid)
        .then(course => {
          commit('set_current_course', course.data)  
          resolve(course)
        }).catch(err => {
          reject(err)
        })
    })
  },
}
